import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './MyCourseListItem.react';
import LinearProgress from 'material-ui/LinearProgress';
import FlatButton from 'material-ui/FlatButton';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import SkillIcon from 'material-ui/svg-icons/social/public';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import ActivityIcon from 'material-ui/svg-icons/action/timeline';
import ComplianceIcon from 'material-ui/svg-icons/action/done-all';
import ModuleIcon from 'material-ui/svg-icons/action/view-module';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import CourseActions from '../../actions/CourseActionCreator';
import CourseStore from '../../stores/CourseStore';

import buildContextMenu from '../Common/BuildContextMenu';

const getSort = (sort) => {
    switch (sort) {
        case 'name':
            return {
                sortCriteria: (a, b) => a.value.localeCompare(b.value),
                sortMapCriteria: (el, i) => ({ index: i, value: el.name }),
                sortOrder: 'ASC'
            };
        case 'code':
            return {
                sortCriteria: (a, b) => a.value.localeCompare(b.value),
                sortMapCriteria: (el, i) => ({ index: i, value: el.code }),
                sortOrder: 'ASC'
            };
        case 'enrolmentDateAsc':
            return {
                sortCriteria: (a, b) => (a.value - b.value),
                sortMapCriteria: (el, i) => ({ index: i, value: Date.parse(el.enrolmentDate) }),
                sortOrder: 'ASC'
            };
        case 'enrolmentDateDesc':
            return {
                sortCriteria: (a, b) => (b.value - a.value),
                sortMapCriteria: (el, i) => ({ index: i, value: Date.parse(el.enrolmentDate) }),
                sortOrder: 'DESC'
            };
        default:
            return {
                sortCriteria: (a, b) => (a.value - b.value),
                sortMapCriteria: (el, i) => ({ index: i, value: el[sort] }),
                sortOrder: 'ASC'
            };
    }
};

class MyCourseList extends Component {

    constructor (props, context) {
        super(props);
        this.state = {
            courses: [],
            actions: buildContextMenu(this.getActions(), context.auth),
            sort: 'name',
            page: 0,
            limit: 50,
            sortCriteria: null,
            sortMapCriteria: null,
            searchPage: 0,
            searchMode: false,
            searchText: null,
            isLoading:  true,
            fetchedAll: false,
            showButton: false
        };
        this.onChange = this.onChange.bind(this);
        this.sort = this.sort.bind(this);
        this.search = this.search.bind(this);
        this.toggleSearchMode = this.toggleSearchMode.bind(this);
        this.loadNextPage = this.loadNextPage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        CourseStore.addChangeListener(this.onChange);
        let params = {limit: this.state.limit};
        if (this.props.completed !== undefined) {
            params.completed = this.props.completed;
        }
        CourseActions.getMy(params);
        CourseActions.getMyProgress();

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        CourseStore.removeChangeListener(this.onChange);
        window.removeEventListener('scroll', this.handleScroll);
    }

    getActions() {
        return [
            {
                link: '/dashboard/mytraining',
                icon: <SchoolIcon />,
                label: 'My training',
            },
            {
                link: '/dashboard/mytraining/compliance',
                icon: <ComplianceIcon />,
                label: 'My compliance',
            },
            {
                link: '/dashboard/mytraining/skills',
                icon: <SkillIcon />,
                label: 'My skills',
            },
            {
                link: '/dashboard/mytraining/courses',
                icon: <SchoolIcon />,
                label: 'My courses',
            },
            {
                link: '/dashboard/mytraining/modules',
                icon: <ModuleIcon />,
                label: 'My modules',
            },
            {
                link: '/dashboard/mytraining/resources',
                icon: <LibraryIcon />,
                label: 'My resources',
            },
            {
                link: '/dashboard/mytraining/activities',
                icon: <ActivityIcon />,
                label: 'My Activities',
            },
            {
                type:'divider'
            },
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },

        ];
    }

    render() {
        return (
            <div ref="myCourses" >
                <ListView
                    title={`My courses${!!this.props.completed ? ' (completed)' : ''}`}
                    sortOptions={this.props.sortOptions}
                    sortAction={this.sort}
                    searchAction={this.search}
                    actions={this.state.actions}
                    items={this.state.courses}
                    itemDecorator={ListItem}
                    toggleSearchMode={this.toggleSearchMode}
                />
                {this.state.isLoading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.isLoading}
                        fullWidth
                    />
                )}
            </div>
        );
    }

    onChange() {
        let courses = CourseStore.getMy();
        if (this.props.completed !== undefined) {
            if (this.props.completed) {
                courses = courses.filter(({enrolmentStatus}) => enrolmentStatus === 'completed');
            } else {
                courses = courses.filter(({enrolmentStatus}) => enrolmentStatus !== 'completed');
            }
        }
        if (!!courses) {
            if (courses.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({courses, isLoading: false});
            } else {
                const mapped = courses.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedCourses= mapped.map((el) => courses[el.index]);
                this.setState({courses: sortedCourses, isLoading: false});
            }
        }
        if (CourseStore.fetchedAll()) {
            this.setState({fetchedAll: true});
        }
    }

    sort({sort}) {
        const { sortCriteria, sortMapCriteria, sortOrder } = getSort(sort);
        this.setState({ sort, sortCriteria, sortMapCriteria });
        CourseActions.getMy({sort, sortOrder});
    }

    search(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            const params = {limit: this.state.limit};
            if (this.props.completed !== undefined) {
                params.completed = this.props.completed;
            }
            this.timeout = setTimeout(() => { CourseActions.searchMy(searchText, params); }, 500);
            if (searchText !== this.state.searchText) {
                this.setState({fetchedAll: false, showButton: false});
            }
            this.setState({searchText, searchPage: 0});
        }
    }

    toggleSearchMode(searchMode) {
        if (!searchMode) {
            this.setState({searchText: null});
        }
        this.setState({searchMode, fetchedAll: false, showButton: false});
    }

    loadNextPage() {
        if (this.state.isLoading) { return; } //guard

        const page = !this.state.searchMode ? (this.state.page + 1) : (this.state.searchPage + 1);
        if (!this.state.searchMode) {
            CourseActions.getMy({page, limit: this.state.limit, completed: this.props.completed !== undefined ? this.props.completed : null});
            this.setState({page, isLoading: true});
        } else if (!!this.state.searchText) {
            CourseActions.searchMy(this.state.searchText, {page, limit: this.state.limit, type: this.props.type});
            this.setState({searchPage: page, isLoading: true});
        }
    }

    handleScroll() {
        if (!this.state.showButton && window.scrollY) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) === this.refs.myCourses.clientHeight) {
            this.loadNextPage();
        }
    }
}

MyCourseList.defaultProps = {
    sortOptions: [
        {label: "Title", value: 'name'},
        {label: "Code", value: 'code'},
        {label: "Enrolment date (Latest)", value: 'enrolmentDateDesc'},
        {label: "Enrolment date (Earliest)", value: 'enrolmentDateAsc'}
    ]
};

MyCourseList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default MyCourseList;
